import { render, staticRenderFns } from "./ProductsCompensationSelected.vue?vue&type=template&id=849ce4a8&"
import script from "./ProductsCompensationSelected.vue?vue&type=script&lang=js&"
export * from "./ProductsCompensationSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports